import api from "./axiosInstance";

export const getCompanyExpenses = async (limit = 10, offset = 0) => {
  const res = await api.get(`api/v1/company-expenses/?limit=${limit}&offset=${offset}`);
  return res.data;
};

export const createCompanyExpenses = async (payload) => {
  const res = await api.post(`api/v1/company-expenses/`, payload);
  return res.data;
};


export const updateCompanyExpenses = async (id, payload) => {
  const res = await api.patch(`api/v1/company-expenses/${id}/`, payload);
  return res.data;
};

export const deleteCompanyExpenses = async (id) => {
  await api.delete(`api/v1/company-expenses/${id}/`);
};